import '../App.css';
import { Link } from "react-router-dom";
import useAuth from '../hooks/useAuth.js';
import { useEffect, useRef, useState } from 'react';

export default function NavigationBar() {
    
    const [showCollapsedMenu, setShowCollapsedMenu] = useState('');
    const [user, setUser] = useState('');
    const navbarRef = useRef(null);

    const toggleMenu = () => {
        showCollapsedMenu === '' ? setShowCollapsedMenu('show') : setShowCollapsedMenu(''); 
    }

    const closeMenu = () => {
        setShowCollapsedMenu('');
    }

    const { auth } = useAuth();

    useEffect(() => {
        const getUserData = async () => {            
            try {                
                if (auth.username === undefined || auth.username === null) {
                    setUser('');
                    return;
                }
                setUser(auth.username);
            } catch (err) {
                console.log('Error in getUserData:', err);
            }
        }
        
        getUserData();
    }, [auth.username, auth.authToken]); // Added auth.authToken as dependency

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navbarRef.current && !navbarRef.current.contains(event.target)) {
                closeMenu();
            }
        }

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        }
    }, []);


    return (
    <nav className='navbar navbar-expand-lg fixed-top navbar-dark navbar-custom' ref={ navbarRef }>
        <div className="container-fluid">
            <button className='navbar-toggler' type='button' data-toggle='collapse' data-target='#navbarNav' onClick={ toggleMenu } aria-expanded='false'>
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className={ 'collapse navbar-collapse' + ' ' +  showCollapsedMenu } id='navbarNav'>
                <ul className='navbar-nav me-auto mb-5 mb-lg-0 align-items-center'>
                    <li className='nav-item'>
                        <Link className='nav-link' to='/' onClick={ toggleMenu }>Home</Link>
                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link' to='/about' onClick={ toggleMenu }>About</Link>
                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link' to='/blog' onClick={ toggleMenu }>Blog</Link>
                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link' to='/artwork' onClick={ toggleMenu }>Artwork</Link>
                    </li>
                    <li className='nav-item'>
                        <Link className='nav-link' to='/photography' onClick={ toggleMenu }>Photography</Link>
                    </li>
                    <li className='nav-item dropdown'>
                        <a className='nav-link dropdown-toggle' href='#' id='navbarDropdown' role='button' data-bs-toggle='dropdown' aria-expanded='false'>
                            Legal
                        </a>
                        <div className='dropdown-menu' aria-labelledby='navbarDropdown'>
                            <Link className='dropdown-item' to='/legal-notice' onClick={ toggleMenu }>Legal Notice</Link>
                            <div className='dropdown-divider'></div>
                            <Link className='dropdown-item' to='/privacy-policy' onClick={ toggleMenu }>Privacy Policy</Link>
                        </div>
                    </li>
                    <li className='nav-item login-nav-item'>
                        <Link to="/login" onClick={ toggleMenu }>
                            <button className='btn btn-outline-dark me-2' type='submit'>Login</button>
                        </Link>
                    </li>
                    { user && (
                        <li className='nav-item'>
                            <Link to="/user-settings" onClick={ toggleMenu } title={ user }>
                                <span className='username-avatar'>
                                    { user ? user.charAt(0).toUpperCase() : '' }
                                </span>
                            </Link>
                        </li>
                    )}
                </ul>
                <form className='d-flex align-items-center'>
                    <input className='form-control ms-5 me-2' type='search' placeholder='Search' aria-label='Search'/>
                    <button className='btn btn-outline-dark me-2' type='submit'>Search</button>
                </form>
            </div>
        </div>
    </nav>
    );
}